<div class="label">
  Te encuentras en:
  <span *ngFor="let item of navigationTree; index as i">
    <span>
      <span [ngSwitch]="i == navigationTree.length - 1">
        <span *ngSwitchCase="true">
          <span class="current-nav">{{ item.label | titlecase }}</span>
        </span>
        <span *ngSwitchCase="false">
          <a href="javascript:;" (click)="navigateTo(item)">{{ item.label }}</a>
        </span>
      </span>
      <span *ngIf="i < navigationTree.length - 1"> | </span>
    </span>
  </span>
</div>
